import { ThemeInterface } from "./styled";

const themeColor = (color: string) => (props: { theme: ThemeInterface }) => {
  return props.theme.pallette[color] || '';
}
export default themeColor;
